import { AccordionLayout } from '../AccordionLayout';
import { AccordionProps } from './types';

export const Accordion = ({ title, index, activeIndex, setActiveIndex, content }: AccordionProps) => (
    <AccordionLayout title={title} index={index} activeIndex={activeIndex} setActiveIndex={setActiveIndex}>
        {content}
    </AccordionLayout>
);
